exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SingleLineEditor-c6593af1{position:relative;min-height:60px}\n", ""]);

// Exports
exports.locals = {
	"SingleLineEditor": "SingleLineEditor-c6593af1"
};